import moment from 'moment-timezone';

export class Feedback {
	public id: number;
	public contractId: string;
	public supplierId: string;
	public userId: string;
	public rating: number;
	public body: string;
	public appId: number;
	public addDate: Date;
	public page: string;
	public feedbackTypeId: number;
	public isReviewed: boolean;
	public canContact: boolean;
	public url: string;

	constructor(feedback?: Feedback) {
		Object.assign(this, feedback);

		this.addDate = this.addDate ? moment(feedback.addDate).toDate() : this.addDate;
	}
}
